"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getFragmentNode(el) {
    if (el == null) {
        return null;
    }
    if (el.dataset && el.dataset.blockKey != null && el.dataset.fragmentStart != null) {
        const _el = el;
        return _el;
    }
    else if (el.parentElement) {
        return getFragmentNode(el.parentElement);
    }
    return null;
}
exports.default = getFragmentNode;
//# sourceMappingURL=getFragmentNode.js.map